import { render, staticRenderFns } from "./SoldPerBuyer.vue?vue&type=template&id=0ee03f8e&"
import script from "./SoldPerBuyer.vue?vue&type=script&lang=js&"
export * from "./SoldPerBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports